<script setup lang="ts">
import { _deletePPT, _putRecoverById } from "@/api";
import { trashPPTList, useTrashPPTList, initPage } from "./use/data";

const router = useRouter();
const { getTrashPPTList } = useTrashPPTList();

onActivated(() => {
  initPage();
  getTrashPPTList();
});

const linkProduct = () => {
  router.push("/product");
};

const recoverPPT = async (index: number) => {
  try {
    await _putRecoverById(trashPPTList[index].serial_no);
    ElMessage.success("恢复成功");
    trashPPTList.splice(index, 1);
  } catch (e: any) {
    ElMessage.error("PPT恢复失败");
  }
};

const deleteTrashPPT = async (index: number) => {
  try {
    await _deletePPT(trashPPTList[index].serial_no);
    ElMessage.success("删除成功");
    trashPPTList.splice(index, 1);
  } catch (e: any) {
    ElMessage.error("删除失败");
  }
};
</script>

<template>
  <div
    class="recycle-container"
    relative
    full
    p-30px
    overflow="y-scroll"
    v-infinite-scroll="getTrashPPTList"
    infinite-scroll-distance="100"
  >
    <div flex items-center mb-20px>
      <div flex items-center cursor-pointer font-bold @click="linkProduct">
        <span class="iconfont ppt-fanhui mr-5 !text-20"></span>
        <span ml-2px text-14px>回收站</span>
      </div>
      <span class="!text-12" color="#999" ml-4px
        >(此处存放你近30天删除，但未手动恢复的作品，过期后会自动清理)</span
      >
    </div>
    <div w-full>
      <PPTListContainer
        full
        :PPTList="trashPPTList"
        type="recycle"
        v-slot="{ index }"
      >
        <div class="menu-item" cursor-pointer @click="recoverPPT(index)">
          <div><span class="iconfont ppt-huifu"></span> <span>恢复</span></div>
        </div>
        <div class="menu-item" cursor-pointer @click="deleteTrashPPT(index)">
          <div>
            <span class="iconfont ppt-delete"></span> <span>永久删除</span>
          </div>
        </div>
      </PPTListContainer>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu-item {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &:hover {
    background-color: #f1f1f1;
  }
  &:last-child {
    border-bottom: 0px;
  }
}
</style>
